import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type Props = {
  title: string;
  summary: string;
  steps: string[];
  reference?: {
    label: string;
    href: string;
  };
};

export function HowItWorksCard({ title, summary, steps, reference }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{summary}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <ol className="list-decimal space-y-2 pl-5 text-sm text-muted-foreground">
          {steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        {reference ? (
          <p className="text-sm text-muted-foreground">
            Reference:{' '}
            <a
              href={reference.href}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-foreground underline-offset-4 hover:underline"
            >
              {reference.label}
            </a>
          </p>
        ) : null}
      </CardContent>
    </Card>
  );
}
